import { Box, Typography } from '@mui/material';
import { NotFoundImage } from '@app/icons';
import { FC } from 'react';

const NoRecordsPlaceholder: FC<{ title: string; text: string }> = ({
  title,
  text,
}) => {
  return (
    <Box display="flex" flexDirection="row" justifyContent="center">
      <Box alignItems="center" display="flex" pb={8} pt={6} px={8} width={0.25}>
        <Box display="flex" flexDirection="column">
          <Box display="flex">
            <Typography variant="subtitle1">{title}</Typography>
          </Box>
          <Box display="flex" mt={1}>
            <Typography>{text}</Typography>
          </Box>
        </Box>
      </Box>
      <Box alignItems="center" display="flex" pb={8} pt={6} px={8}>
        <NotFoundImage />
      </Box>
    </Box>
  );
};

export default NoRecordsPlaceholder;
